var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8722 15.1264C12.3357 17.0562 10.4264 18.6349 8.26348 19.7663C6.10054 18.6349 4.19037 17.0562 2.65639 15.1264C0.20641 11.8991 0.50622 7.45645 0.50622 7.4132V1.8919C5.59275 0.650618 10.8914 0.650618 15.9762 1.8919V7.4132C16.0015 7.45818 16.2935 11.9354 13.8722 15.1264Z",
    fill: "#4AC600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0182 5.5498L7.31631 11.4628L4.58656 8.66377L3.51807 9.7441L6.78042 13.0899C6.91887 13.2317 7.10802 13.3087 7.30642 13.3087H7.30889C7.50898 13.3087 7.70229 13.2248 7.83737 13.0829L14.0776 6.62586L13.0182 5.5498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.98518af03fcd763d8806bc44e82d2731.svg";
export { ForwardRef as ReactComponent };